export class RadioButtonItem {
    Name: string;
    Value: any;
    Disabled: boolean;
    id: number = parseInt((Math.random() * 100).toFixed(0));
}